import { useParams } from "react-router-dom";
import { EVALUATION_TYPES } from "../../../../../components/dashboard/hse/evaluation/evaluationUtils";
import { EvaluationViewPage } from "../../../../../components/dashboard/hse/evaluation/EvaluationViewPage";

export const HseKsAuditFindings = () => {
  const { id } = useParams();
  return <EvaluationViewPage evaluationType={EVALUATION_TYPES.INTERNAL_AUDIT} id={id} />;
};
